/** Optional images for manual ad ingest (Slice 17b); uploads run after post save. */
export function AdsAssistantManualPostMediaField(props: {
  disabled: boolean;
  files: File[];
  onFilesChange: (files: File[]) => void;
}) {
  const { disabled, files, onFilesChange } = props;

  return (
    <div className="rounded-lg border border-dashed border-gray-300 bg-white/60 px-2 py-2 dark:border-zinc-600 dark:bg-zinc-950/30">
      <label className="block text-[11px] font-medium text-gray-700 dark:text-gray-300">
        Post images (optional)
        <input
          type="file"
          accept="image/jpeg,image/png,image/webp"
          multiple
          disabled={disabled}
          className="mt-1 block w-full text-xs file:mr-2 file:rounded file:border-0 file:bg-blue-50 file:px-2 file:py-1 file:text-xs file:font-medium file:text-blue-800 dark:file:bg-zinc-800 dark:file:text-blue-200"
          onChange={(e) => {
            const picked = Array.from(e.target.files ?? []);
            const max = 6;
            const maxBytes = 8 * 1024 * 1024;
            const allowed = new Set(["image/jpeg", "image/png", "image/webp"]);
            const next = picked
              .filter((f) => allowed.has((f.type || "image/jpeg").toLowerCase()))
              .filter((f) => f.size <= maxBytes)
              .slice(0, max);
            onFilesChange(next);
            e.target.value = "";
          }}
        />
      </label>
      {files.length ? (
        <ul className="mt-1.5 list-inside list-disc text-[10px] text-gray-600 dark:text-gray-400" aria-label="Selected images">
          {files.map((f) => (
            <li key={`${f.name}-${f.size}-${f.lastModified}`}>
              {f.name} ({Math.round(f.size / 1024)} KB)
            </li>
          ))}
        </ul>
      ) : (
        <p className="mt-1 text-[10px] text-gray-500 dark:text-gray-500">Up to 6 files, max 8 MB each (JPEG, PNG, WebP).</p>
      )}
    </div>
  );
}
